import './../base';
import 'lity'; //Import Theme Styles

import '../../styles/layout/theme.scss'; //Theme Animations

import '../components/animations/fade-in'; //Theme Objects

import '../objects/product/ProductThumbnail';
import '../objects/add-to-cart/UpdateCounter';
import '../objects/read-more'; //Theme Components

import '../components/static/header';
import '../components/static/footer';
import '../components/navigation/header-navigation';
import '../components/carousels/quotes-carousel';
import '../components/carousels/home-reviews';
import '../components/carousels/home-concerns';
import '../components/cart/cart-drawer';
import '../components/cart/upsell-slider';
import '../components/cart/cart-drawer-component';
import '../components/cart/cart-scroll';
import '../components/carousels/product-single-carousel'; // TODO: Move this into correct template

import '../templates/customers/account-page';
import '../templates/article.recipe';
import '../templates/page.our-story';
import '../templates/page.stockists'; //Theme Tools

if (process.env.NODE_ENV === 'development') {
  require('../tools/layout/grid-view/grid-view');
} // Let CSS know JS is available


document.documentElement.classList.remove('js-unavailable');
document.documentElement.classList.add('js-available');